import { first, last, size } from 'lodash'

export function parseDecimal(value: string): number | undefined {
  if (value === undefined || value === null) {
    return undefined
  }
  const result = Number.parseFloat(prepareDecimalString(String(value)))
  return result
}

function prepareDecimalString(value: string): string {
  const chars = value.match(/[., ']/g)
  const separatorChar = size(chars) > 1 ? first(chars) : undefined
  const decimalChar = last(chars)
  const result = value
    .replaceAll(separatorChar as string, '')
    .replaceAll(decimalChar as string, '.')
  // console.log('prepareDecimalString', {
  //   value,
  //   result,
  //   chars,
  //   separatorChar,
  //   decimalChar,
  // })
  return result
}
